import SortIcon from "../../../global/components/SortIcon";
import { formatUTCTime } from "../../../global/utils/unixToLocalTime";

function sortableHeader(modParams, setParams, columnKey) {
  return {
    sorter: () => {},
    sortIcon: () => (
      <SortIcon
        sortOrder={modParams.order}
        columnKey={columnKey}
        sortBy={modParams.sort_by}
      />
    ),
    onHeaderCell: () => ({
      onClick: () =>
        setParams({
          ...modParams,
          sort_by: columnKey,
          order:
            modParams.sort_by === columnKey && modParams.order === "desc"
              ? "asc"
              : "desc",
        }),
    }),
  };
}

export const AuditLogColumns = (setParams, params) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};

  return [
    {
      title: "No",
      dataIndex: "AuditNo",
      key: "AuditNo",
      width: 80,
      ...sortableHeader(modParams, setParams, "AuditNo"),
    },
    {
      title: "Audit Time",
      dataIndex: "AuditTime",
      key: "AuditTime",
      width: 170,
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      ...sortableHeader(modParams, setParams, "AuditTime"),
    },
    {
      title: "Account",
      dataIndex: "AccountUserId",
      key: "AccountUserId",
      width: 180,
      ...sortableHeader(modParams, setParams, "AccountUserId"),
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      ...sortableHeader(modParams, setParams, "Description"),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 1,
    },
  ];
};
